import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=5807d951"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=5807d951&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports